import React from 'react';
import {useTranslation} from 'react-i18next';

import GoogleMaps from '../google-maps/GoogleMaps';

const locations = [
  {
    key: 'hamburg',
    mapId: 'google-maps-hamburg',
  },
  {
    key: 'neu_wulmstorf',
    mapId: 'google-maps-neu-wulmstorf',
  },
];

const ContactsLocations = () => {
  const {t} = useTranslation();

  return (
    <section className="contacts-locations">
      {locations.map((location) => {
        const transportItems = t(`contacts_page.locations.${location.key}.public_transport`, {
          returnObjects: true,
        });
        const carItems = t(`contacts_page.locations.${location.key}.car`, {
          returnObjects: true,
        });

        return (
          <article key={location.key} className="contacts-location-card">
            <div className="contacts-location-header">
              <h2>{t(`contacts_page.locations.${location.key}.title`)}</h2>
              <p className="contacts-location-address">
                {t(`contacts_page.locations.${location.key}.address`)}
              </p>
            </div>

            <GoogleMaps
              mapId={location.mapId}
              title={t(`contacts_page.locations.${location.key}.title`)}
              address={t(`contacts_page.locations.${location.key}.address`)}
            />

            <div className="contacts-location-info">
              <div className="contacts-location-group">
                <h6>{t('contacts_page.transport_title')}</h6>
                {(Array.isArray(transportItems) ? transportItems : []).map((item) => (
                  <p key={item}>{item}</p>
                ))}
              </div>

              <div className="contacts-location-group">
                <h6>{t('contacts_page.car_title')}</h6>
                {(Array.isArray(carItems) ? carItems : []).map((item) => (
                  <p key={item}>{item}</p>
                ))}
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
};

export default ContactsLocations;
